import { Chip, makeStyles } from '@material-ui/core';
import OutlinedDiv from './OutlinedDiv';
import { Bold, Italic } from './TextFormatters';

const useStyles = makeStyles(theme => ({
  chip: {
    margin: 2,
  },
  chipsWrapper: {
    marginTop: 10,
  },
  emptyMessage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 .4em .4em .4em',
    color: 'rgba(0,0,0,.45)',
  },
}));

const GroupedChips = ({ label, options, optionsDisplay }) => {
  const classes = useStyles();
  return (
    <div className={classes.chipsWrapper}>
      <OutlinedDiv label={label}>
        {options.isEmpty() ? (
          <div className={classes.emptyMessage}>
            <Italic>
              <Bold>{`Sin ${label.toLowerCase()}`}</Bold>
            </Italic>
          </div>
        ) : (
          options.map(item => (
            <Chip
              color="primary"
              className={classes.chip}
              size="small"
              label={optionsDisplay ? optionsDisplay(item) : item}
              // onDelete={() => deleteAttachment(att)}
            />
          ))
        )}
      </OutlinedDiv>
    </div>
  );
};

export default GroupedChips;
